function bootKoConfigurators() {
  document.querySelectorAll(".ko-konfig").forEach(section => {
    if (section.dataset.koInitialized === "true") return;
    section.dataset.koInitialized = "true";
    initKoConfigurator(section);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootKoConfigurators);
} else {
  bootKoConfigurators();
}

document.addEventListener("shopify:section:load", event => {
  const section = event.target.querySelector(".ko-konfig") || event.target;

  if (section?.classList?.contains("ko-konfig")) {
    section.dataset.koInitialized = "false";
  }

  bootKoConfigurators();
});

document.addEventListener("shopify:block:select", bootKoConfigurators);

function initKoConfigurator(section) {
  const FORMSPREE_ENDPOINT = "https://formspree.io/f/mrbyeyea";
  const jsonEl = section.querySelector('[data-role="product-config-json"]');
  let rows = [];

  try {
    rows = jsonEl ? JSON.parse(jsonEl.textContent || "[]") : [];
  } catch (error) {
    console.error("KO Config JSON Fehler:", error);
  }

  rows = rows.map(row => ({
    product: normalizeKey(row.product),
    product_name: row.product_name || row.product || "",
    variant: row.variant || "",
    product_color: normalizeKey(row.product_color || row.color || row.color_key),
    product_color_label: row.product_color_label || row.color_label || row.color || row.product_color || "",
    packaging: normalizeKey(row.packaging),
    packaging_label: row.packaging_label || row.packaging || "",
    packaging_color: normalizeKey(row.packaging_color || row.packaging_color_key || row.packaging),
    packaging_color_label: row.packaging_color_label || row.packaging_color || row.packaging_label || row.packaging || "",
    quantity: String(row.quantity || "").trim(),
    quantity_label: row.quantity_label || row.quantity || "",
    unit_price: row.unit_price || "",
    total_price: row.total_price || "",
    product_image: row.product_image || "",
    packaging_image: row.packaging_image || row.packaging_front || ""
  })).filter(row =>
    row.product &&
    row.product_name &&
    row.product_color &&
    row.product_color_label
  );

  const state = {
    step: 1,
    product: null,
    productColor: null,
    packaging: null,
    packagingColor: null,
    quantity: null,
    activeSurface: "product",
    activeLayerId: null,
    layers: []
  };

  const productGrid = section.querySelector('[data-role="product-grid"]');
  const productColorGrid = section.querySelector('[data-role="product-color-grid"]');
  const packagingGrid = section.querySelector('[data-role="packaging-grid"]');
  const packagingColorGrid = section.querySelector('[data-role="packaging-color-grid"]');
  const pricingGrid = section.querySelector('[data-role="pricing-grid"]');

  const productImage = section.querySelector('[data-role="preview-product-image"]');
  const packagingImage = section.querySelector('[data-role="preview-packaging-image"]');

  const miniProductPreview = section.querySelector('[data-role="mini-product-preview"]');
  const miniPackagingPreview = section.querySelector('[data-role="mini-packaging-preview"]');

  const uploadArea = section.querySelector('[data-role="upload-area"]');
  const fileInput = section.querySelector('[data-role="file-input"]');
  const layerList = section.querySelector('[data-role="layer-list"]');

  renderProducts();
  bindNavigation();
  bindUpload();
  bindSurfaceButtons();
  bindCart();
  createControls();
  updatePreview();
  updateLayerCounts();

  function renderProducts() {
    if (!productGrid) return;

    const products = uniqueBy(rows, row => row.product);

    if (!products.length) {
      productGrid.innerHTML = `
        <div class="ko-konfig__notice">
          Keine Produkte gefunden. Bitte im Shopify Editor mindestens einen Produkt/Farbe/Verpackung/Preis-Block anlegen.
        </div>
      `;
      return;
    }

    productGrid.innerHTML = products.map(row => `
      <button type="button" class="ko-konfig__product-card" data-product="${escapeHtml(row.product)}">
        <span class="ko-konfig__product-name">${escapeHtml(row.product_name)}</span>
        <span class="ko-konfig__product-copy">Produktfarbe, Verpackung und Menge auswählen</span>
      </button>
    `).join("");

    productGrid.querySelectorAll("[data-product]").forEach(button => {
      button.addEventListener("click", () => {
        state.product = button.dataset.product;
        state.productColor = null;
        state.packaging = null;
        state.packagingColor = null;
        state.quantity = null;

        setActive(productGrid, button);
        renderProductColors();
        clearGrid(packagingGrid);
        clearGrid(packagingColorGrid);
        clearGrid(pricingGrid);
        clearImage(miniProductPreview);
        clearImage(miniPackagingPreview);
        clearImage(packagingImage);
        updatePreview();

        enable("to-step-2");
        disable("to-step-3");
        disable("to-step-4");
        disable("to-step-5");
        disable("to-step-6");
      });
    });
  }

  function renderProductColors() {
    if (!productColorGrid) return;

    const filtered = rows.filter(row => row.product === state.product);
    const colors = uniqueBy(filtered, row => row.product_color);

    const oneColorPrintProducts = [
      "silikon-6-8cm",
      "silikon-6-8-cm",
      "silikon-7-9cm",
      "silikon-7-9-cm",
      "silikon-9-11cm",
      "silikon-9-11-cm",
      "latex"
    ];

    const needsOneColorPrintNotice = oneColorPrintProducts.includes(state.product);

    const printNotice = needsOneColorPrintNotice
      ? `
        <div class="ko-konfig__notice ko-konfig__print-notice">
          Hinweis: Auf diesem Deckel ist nur ein einfarbiger Druck möglich.
        </div>
      `
      : "";

    productColorGrid.innerHTML = printNotice + colors.map(row => `
      <button type="button" class="ko-konfig__color-card" data-product-color="${escapeHtml(row.product_color)}">
        <strong>${escapeHtml(row.product_color_label)}</strong>
      </button>
    `).join("");

    productColorGrid.querySelectorAll("[data-product-color]").forEach(button => {
      button.addEventListener("click", () => {
        state.productColor = button.dataset.productColor;
        state.packaging = null;
        state.packagingColor = null;
        state.quantity = null;

        setActive(productColorGrid, button);
        renderPackagings();
        clearGrid(packagingColorGrid);
        clearGrid(pricingGrid);
        clearImage(miniPackagingPreview);
        clearImage(packagingImage);
        updatePreview();

        enable("to-step-3");
        disable("to-step-4");
        disable("to-step-5");
        disable("to-step-6");
      });
    });
  }

  function renderPackagings() {
    if (!packagingGrid) return;

    const filtered = rows.filter(row =>
      row.product === state.product &&
      row.product_color === state.productColor
    );

    const packagings = uniqueBy(filtered, row => row.packaging);

    packagingGrid.innerHTML = packagings.map(row => `
      <button type="button" class="ko-konfig__packaging-card" data-packaging="${escapeHtml(row.packaging)}">
        <span class="ko-konfig__packaging-title">${escapeHtml(row.packaging_label)}</span>
        <span class="ko-konfig__packaging-copy">Verpackungsfarbe auswählen</span>
      </button>
    `).join("");

    packagingGrid.querySelectorAll("[data-packaging]").forEach(button => {
      button.addEventListener("click", () => {
        state.packaging = button.dataset.packaging;
        state.packagingColor = null;
        state.quantity = null;

        setActive(packagingGrid, button);
        renderPackagingColors();
        clearGrid(pricingGrid);
        clearImage(miniPackagingPreview);
        clearImage(packagingImage);
        updatePreview();

        enable("to-step-4");
        disable("to-step-5");
        disable("to-step-6");
      });
    });
  }

  function renderPackagingColors() {
    if (!packagingColorGrid) return;

    const filtered = rows.filter(row =>
      row.product === state.product &&
      row.product_color === state.productColor &&
      row.packaging === state.packaging
    );

    const colors = uniqueBy(filtered, row => row.packaging_color);

    packagingColorGrid.innerHTML = colors.map(row => `
      <button type="button" class="ko-konfig__color-card" data-packaging-color="${escapeHtml(row.packaging_color)}">
        <strong>${escapeHtml(row.packaging_color_label)}</strong>
      </button>
    `).join("");

    packagingColorGrid.querySelectorAll("[data-packaging-color]").forEach(button => {
      button.addEventListener("click", () => {
        state.packagingColor = button.dataset.packagingColor;
        state.quantity = null;

        setActive(packagingColorGrid, button);
        renderPricing();
        updatePreview();

        enable("to-step-5");
        disable("to-step-6");
      });
    });
  }

  function renderPricing() {
    if (!pricingGrid) return;

    const filtered = rows.filter(row =>
      row.product === state.product &&
      row.product_color === state.productColor &&
      row.packaging === state.packaging &&
      row.packaging_color === state.packagingColor
    );

    const prices = uniqueBy(filtered, row => row.quantity || row.quantity_label || row.variant);

    if (!prices.length) {
      pricingGrid.innerHTML = `
        <div class="ko-konfig__notice">
          Für diese Auswahl wurde noch keine Preisstaffel angelegt.
        </div>
      `;
      return;
    }

    pricingGrid.innerHTML = prices.map(row => `
      <button type="button" class="ko-konfig__pricing-card" data-quantity="${escapeHtml(row.quantity)}">
        <div class="ko-konfig__pricing-qty">${escapeHtml(row.quantity_label || row.quantity || "Menge")}</div>
        <div class="ko-konfig__pricing-unit">${escapeHtml(row.unit_price || "–")} <span>/ Stück</span></div>
        <div class="ko-konfig__pricing-total">Gesamt: ${escapeHtml(row.total_price || "–")}</div>
      </button>
    `).join("");

    pricingGrid.querySelectorAll("[data-quantity]").forEach(button => {
      button.addEventListener("click", () => {
        state.quantity = button.dataset.quantity;

        setActive(pricingGrid, button);
        updatePreview();

        enable("to-step-6");
      });
    });
  }

  function getSelectedRow() {
    return rows.find(row =>
      row.product === state.product &&
      row.product_color === state.productColor &&
      row.packaging === state.packaging &&
      row.packaging_color === state.packagingColor &&
      row.quantity === state.quantity
    );
  }

  function getPartialRow() {
    return rows.find(row =>
      (!state.product || row.product === state.product) &&
      (!state.productColor || row.product_color === state.productColor) &&
      (!state.packaging || row.packaging === state.packaging) &&
      (!state.packagingColor || row.packaging_color === state.packagingColor) &&
      (!state.quantity || row.quantity === state.quantity)
    );
  }

  function updatePreview() {
    const selected = getSelectedRow();
    const partial = selected || getPartialRow();

    if (!partial) {
      clearImage(productImage);
      clearImage(packagingImage);
      clearImage(miniProductPreview);
      clearImage(miniPackagingPreview);
      updateSummary(null);
      updateLayerCounts();
      return;
    }

    setImage(productImage, partial.product_image);
    setImage(miniProductPreview, partial.product_image);

    if (state.packaging || state.packagingColor || selected) {
      setImage(packagingImage, partial.packaging_image);
      setImage(miniPackagingPreview, partial.packaging_image);
    } else {
      clearImage(packagingImage);
      clearImage(miniPackagingPreview);
    }

    updateSummary(partial);
    updateLayerCounts();
  }

  function updateSummary(row) {
    updateText("preview-product-name", row?.product_name || "–");
    updateText("preview-product-color", row?.product_color_label || "–");
    updateText("preview-packaging", row?.packaging_label || "–");
    updateText("preview-packaging-color", row?.packaging_color_label || "–");
    updateText("preview-quantity", row?.quantity_label || row?.quantity || "–");
    updateText("preview-unit-price", row?.unit_price || "–");
    updateText("preview-total-price", row?.total_price || "–");

    updateText("sum-product", row?.product_name || "–");
    updateText("sum-product-color", row?.product_color_label || "–");
    updateText("sum-packaging", row?.packaging_label || "–");
    updateText("sum-packaging-color", row?.packaging_color_label || "–");
    updateText("sum-quantity", row?.quantity_label || row?.quantity || "–");
    updateText("sum-unit-price", row?.unit_price || "–");
    updateText("sum-total-price", row?.total_price || "–");
  }

  function bindNavigation() {
    section.querySelectorAll("[data-action]").forEach(button => {
      const action = button.dataset.action || "";

      if (action.startsWith("to-step-")) {
        button.addEventListener("click", () => {
          goToStep(Number(action.replace("to-step-", "")));
        });
      }

      if (action.startsWith("back-")) {
        button.addEventListener("click", () => {
          goToStep(Number(action.replace("back-", "")));
        });
      }
    });
  }

  function goToStep(step) {
    state.step = step;

    section.querySelectorAll("[data-panel]").forEach(panel => {
      panel.classList.toggle("ko-konfig__panel--active", Number(panel.dataset.panel) === step);
    });

    section.querySelectorAll("[data-step]").forEach(stepEl => {
      const stepNumber = Number(stepEl.dataset.step);
      stepEl.classList.toggle("ko-konfig__step--active", stepNumber === step);
      stepEl.classList.toggle("ko-konfig__step--completed", stepNumber < step);
    });

    if (step === 7) {
      createControls();
      syncControls();
    }

    updatePreview();
  }

  function bindSurfaceButtons() {
    section.querySelectorAll("[data-surface-target]").forEach(button => {
      button.addEventListener("click", () => {
        state.activeSurface = button.dataset.surfaceTarget || "product";

        section.querySelectorAll("[data-surface-target]").forEach(btn => {
          btn.classList.remove("is-active");
        });

        button.classList.add("is-active");
      });
    });
  }

  function bindUpload() {
    if (!uploadArea || !fileInput) return;

    uploadArea.addEventListener("click", () => {
      fileInput.click();
    });

    uploadArea.addEventListener("dragover", event => {
      event.preventDefault();
      uploadArea.classList.add("is-dragover");
      uploadArea.classList.add("ko-konfig__upload-area--dragover");
    });

    uploadArea.addEventListener("dragleave", () => {
      uploadArea.classList.remove("is-dragover");
      uploadArea.classList.remove("ko-konfig__upload-area--dragover");
    });

    uploadArea.addEventListener("drop", event => {
      event.preventDefault();
      uploadArea.classList.remove("is-dragover");
      uploadArea.classList.remove("ko-konfig__upload-area--dragover");
      handleFiles(event.dataTransfer.files);
    });

    fileInput.addEventListener("change", event => {
      handleFiles(event.target.files);
      fileInput.value = "";
    });
  }

  function handleFiles(files) {
    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/svg+xml",
      "application/pdf"
    ];

    Array.from(files || []).forEach(file => {
      if (!allowedTypes.includes(file.type)) {
        showError("Bitte nur PNG, JPG, SVG oder PDF hochladen.");
        return;
      }

      if (file.size > 25 * 1024 * 1024) {
        showError("Die Datei ist größer als 25MB.");
        return;
      }

      const isPdf = file.type === "application/pdf";
      const reader = new FileReader();

      reader.onload = event => {
        const layer = {
          id: `layer-${Date.now()}-${Math.random().toString(16).slice(2)}`,
          name: file.name,
          src: event.target.result,
          surface: state.activeSurface,
          x: 50,
          y: 50,
          scale: 1,
          rotation: 0,
          fileType: file.type,
          fileSize: file.size,
          originalFile: file,
          isPdf: isPdf
        };

        state.layers.push(layer);

        if (!isPdf) {
          renderLayer(layer);
          selectLayer(layer.id);
        } else {
          state.activeLayerId = layer.id;
          showError("PDF wurde gespeichert, aber nicht in der Live-Vorschau angezeigt.");
        }

        renderLayerList();
        updateLayerCounts();
        syncControls();
      };

      reader.readAsDataURL(file);
    });
  }

  function renderLayer(layer) {
    if (layer.isPdf) return;

    const container = getLayerContainer(layer.surface);
    if (!container) return;

    const oldLayer = section.querySelector(`[data-layer-id="${cssEscape(layer.id)}"]`);
    if (oldLayer) oldLayer.remove();

    const img = document.createElement("img");
    img.src = layer.src;
    img.alt = layer.name;
    img.className = "ko-konfig__logo-layer";
    img.dataset.layerId = layer.id;
    img.draggable = false;

    applyLayerStyle(img, layer);
    makeDraggable(img, layer);

    img.addEventListener("click", event => {
      event.stopPropagation();
      selectLayer(layer.id);
    });

    container.appendChild(img);
  }

  function makeDraggable(el, layer) {
    let dragging = false;

    el.addEventListener("pointerdown", event => {
      event.preventDefault();
      dragging = true;
      selectLayer(layer.id);
      el.setPointerCapture(event.pointerId);
    });

    el.addEventListener("pointermove", event => {
      if (!dragging) return;

      const surface = el.closest(".ko-konfig__design-surface");
      if (!surface) return;

      const rect = surface.getBoundingClientRect();

      layer.x = ((event.clientX - rect.left) / rect.width) * 100;
      layer.y = ((event.clientY - rect.top) / rect.height) * 100;

      layer.x = clamp(layer.x, 0, 100);
      layer.y = clamp(layer.y, 0, 100);

      applyLayerStyle(el, layer);
      syncControls();
    });

    el.addEventListener("pointerup", event => {
      dragging = false;

      try {
        el.releasePointerCapture(event.pointerId);
      } catch (_) {}
    });

    el.addEventListener("pointercancel", () => {
      dragging = false;
    });

    el.addEventListener("wheel", event => {
      event.preventDefault();
      selectLayer(layer.id);

      if (event.shiftKey) {
        layer.rotation += event.deltaY > 0 ? 6 : -6;
        layer.rotation = clamp(layer.rotation, -180, 180);
      } else {
        layer.scale += event.deltaY > 0 ? -0.08 : 0.08;
        layer.scale = clamp(layer.scale, 0.2, 4);
      }

      applyLayerStyle(el, layer);
      syncControls();
    }, { passive: false });
  }

  function createControls() {
    const editorSidebar =
      section.querySelector(".ko-konfig__editor-sidebar") ||
      section.querySelector('[data-panel="7"] .ko-konfig__editor-layout') ||
      section.querySelector('[data-panel="7"]');

    if (!editorSidebar) return;
    if (section.querySelector('[data-role="logo-controls"]')) return;

    const controls = document.createElement("div");
    controls.className = "ko-konfig__editor-card ko-konfig__logo-controls";
    controls.dataset.role = "logo-controls";

    controls.innerHTML = `
      <div class="ko-konfig__editor-card-head">
        <strong>Logo bearbeiten</strong>
      </div>

      <div class="ko-konfig__editor-row">
        <span>Aktives Element</span>
        <strong data-role="active-layer-name">–</strong>
      </div>

      <div class="ko-konfig__editor-group">
        <label class="ko-konfig__control-label">Größe</label>
        <div class="ko-konfig__control">
          <input type="range" min="20" max="400" value="100" step="1" data-role="logo-scale-range">
          <strong data-role="logo-scale-value">100%</strong>
        </div>
      </div>

      <div class="ko-konfig__editor-group">
        <label class="ko-konfig__control-label">Drehung</label>
        <div class="ko-konfig__control">
          <input type="range" min="-180" max="180" value="0" step="1" data-role="logo-rotate-range">
          <strong data-role="logo-rotate-value">0°</strong>
        </div>
      </div>

      <div class="ko-konfig__editor-actions">
        <button type="button" class="ko-konfig__btn ko-konfig__btn--secondary ko-konfig__btn--full" data-action-custom="reset-active-layer">
          Aktives Element zurücksetzen
        </button>
        <button type="button" class="ko-konfig__btn ko-konfig__btn--secondary ko-konfig__btn--full" data-action-custom="delete-active-layer">
          Aktives Element löschen
        </button>
      </div>

      <p class="ko-konfig__editor-help">
        Logo in der Vorschau anklicken, verschieben, Größe anpassen oder drehen.
      </p>
    `;

    editorSidebar.appendChild(controls);

    const scaleRange = section.querySelector('[data-role="logo-scale-range"]');
    const rotateRange = section.querySelector('[data-role="logo-rotate-range"]');

    scaleRange?.addEventListener("input", event => {
      const layer = getActiveLayer();
      if (!layer || layer.isPdf) return;

      layer.scale = Number(event.target.value) / 100;
      layer.scale = clamp(layer.scale, 0.2, 4);

      applyActiveLayerStyle();
      syncControls();
    });

    rotateRange?.addEventListener("input", event => {
      const layer = getActiveLayer();
      if (!layer || layer.isPdf) return;

      layer.rotation = Number(event.target.value);
      layer.rotation = clamp(layer.rotation, -180, 180);

      applyActiveLayerStyle();
      syncControls();
    });

    section.querySelector('[data-action-custom="reset-active-layer"]')?.addEventListener("click", () => {
      const layer = getActiveLayer();
      if (!layer || layer.isPdf) return;

      layer.x = 50;
      layer.y = 50;
      layer.scale = 1;
      layer.rotation = 0;

      applyActiveLayerStyle();
      syncControls();
      renderLayerList();
    });

    section.querySelector('[data-action-custom="delete-active-layer"]')?.addEventListener("click", () => {
      const layer = getActiveLayer();
      if (!layer) return;

      deleteLayer(layer.id);
    });

    syncControls();
  }

  function selectLayer(id) {
    state.activeLayerId = id;

    section.querySelectorAll(".ko-konfig__logo-layer").forEach(el => {
      el.classList.toggle("is-active", el.dataset.layerId === id);
    });

    renderLayerList();
    syncControls();
  }

  function getActiveLayer() {
    return state.layers.find(layer => layer.id === state.activeLayerId);
  }

  function applyActiveLayerStyle() {
    const layer = getActiveLayer();
    if (!layer || layer.isPdf) return;

    const el = section.querySelector(`[data-layer-id="${cssEscape(layer.id)}"]`);
    if (el) applyLayerStyle(el, layer);
  }

function applyLayerStyle(el, layer) {
  el.style.position = "absolute";
  el.style.left = `${layer.x}%`;
  el.style.top = `${layer.y}%`;
  el.style.width = `${120 * layer.scale}px`;
  el.style.height = "auto";
  el.style.transform = `translate(-50%, -50%) rotate(${layer.rotation}deg)`;
  el.style.transformOrigin = "center center";
  el.style.zIndex = "5";
}

  function syncControls() {
    const layer = getActiveLayer();

    updateText("active-layer-name", layer ? layer.name : "–");

    const scaleRange = section.querySelector('[data-role="logo-scale-range"]');
    const scaleValue = section.querySelector('[data-role="logo-scale-value"]');
    const rotateRange = section.querySelector('[data-role="logo-rotate-range"]');
    const rotateValue = section.querySelector('[data-role="logo-rotate-value"]');

    if (!layer || layer.isPdf) {
      if (scaleRange) scaleRange.value = 100;
      if (scaleValue) scaleValue.textContent = "100%";
      if (rotateRange) rotateRange.value = 0;
      if (rotateValue) rotateValue.textContent = "0°";
      return;
    }

    const scalePercent = Math.round(layer.scale * 100);
    const rotation = Math.round(layer.rotation);

    if (scaleRange) scaleRange.value = scalePercent;
    if (scaleValue) scaleValue.textContent = `${scalePercent}%`;
    if (rotateRange) rotateRange.value = rotation;
    if (rotateValue) rotateValue.textContent = `${rotation}°`;
  }

  function renderLayerList() {
    if (!layerList) return;

    if (!state.layers.length) {
      layerList.innerHTML = "";
      return;
    }

    layerList.innerHTML = state.layers.map(layer => `
      <div class="ko-konfig__layer-item ${layer.id === state.activeLayerId ? "is-active" : ""}">
        <button type="button" data-select-layer="${escapeHtml(layer.id)}">
          ${escapeHtml(layer.name)}${layer.isPdf ? " · Druckdatei" : ""}
        </button>
        <button type="button" data-delete-layer="${escapeHtml(layer.id)}">
          Löschen
        </button>
      </div>
    `).join("");

    layerList.querySelectorAll("[data-select-layer]").forEach(button => {
      button.addEventListener("click", () => {
        selectLayer(button.dataset.selectLayer);
      });
    });

    layerList.querySelectorAll("[data-delete-layer]").forEach(button => {
      button.addEventListener("click", () => {
        deleteLayer(button.dataset.deleteLayer);
      });
    });
  }

  function deleteLayer(id) {
    state.layers = state.layers.filter(layer => layer.id !== id);

    const el = section.querySelector(`[data-layer-id="${cssEscape(id)}"]`);
    if (el) el.remove();

    if (state.activeLayerId === id) {
      state.activeLayerId = state.layers.length ? state.layers[state.layers.length - 1].id : null;
    }

    if (state.activeLayerId) {
      selectLayer(state.activeLayerId);
    } else {
      section.querySelectorAll(".ko-konfig__logo-layer").forEach(layerEl => {
        layerEl.classList.remove("is-active");
      });

      renderLayerList();
      syncControls();
    }

    updateLayerCounts();
  }

  function getLayerContainer(surface) {
    if (surface === "product") {
      return section.querySelector('[data-role="layers-product"]');
    }

    if (surface === "packaging_front") {
      return section.querySelector('[data-role="layers-packaging"]');
    }

    return null;
  }

  function updateLayerCounts() {
    const count = state.layers.length;

    updateText("layer-count", `${count} ${count === 1 ? "Element" : "Elemente"}`);
    updateText("preview-layer-count", String(count));
    updateText("sum-file", String(count));

    toggleEmpty("empty-product", "product");
    toggleEmpty("empty-packaging", "packaging_front");
  }

  function toggleEmpty(role, surface) {
    const el = section.querySelector(`[data-role="${role}"]`);
    if (!el) return;

    el.hidden = state.layers.some(layer =>
      layer.surface === surface &&
      !layer.isPdf
    );
  }

  function bindCart() {
  const cartButton = section.querySelector('[data-action="add-to-cart"]');
  if (!cartButton) return;

  cartButton.addEventListener("click", async () => {
    const selected = getSelectedRow();

    if (!selected) {
      showError("Bitte wählen Sie Produkt, Produktfarbe, Verpackung, Verpackungsfarbe und Stückzahl aus.");
      return;
    }

    if (!selected.variant) {
      showError("Bitte Variant ID im Shopify Editor für diese Preisstaffel hinterlegen.");
      return;
    }

    cartButton.disabled = true;
    cartButton.textContent = "Wird gesendet...";

    try {
      await sendConfigurationToFormspree(selected);

      cartButton.textContent = "Wird hinzugefügt...";

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: Number(selected.variant),
          quantity: 1,
          properties: {
            Produkt: selected.product_name,
            Produktfarbe: selected.product_color_label,
            Verpackung: selected.packaging_label,
            Verpackungsfarbe: selected.packaging_color_label,
            Stückzahl: selected.quantity_label || selected.quantity,
            "Preis pro Stück": selected.unit_price,
            Gesamtpreis: selected.total_price,
            "Design-Elemente": String(state.layers.length)
          }
        })
      });

      if (!response.ok) throw new Error("Cart error");

      window.location.href = "/cart";
    } catch (error) {
      console.error("KO Config Anfrage/Warenkorb Fehler:", error);
      showError("Die Anfrage konnte nicht gesendet werden. Bitte prüfen Sie die Uploads oder kontaktieren Sie uns direkt.");
      cartButton.disabled = false;
      cartButton.textContent = "In den Warenkorb";
    }
  });
}

async function sendConfigurationToFormspree(selected) {
  const fd = new FormData();
  const orderId = `KO-${Date.now()}`;
  const designLayers = getSerializableLayers();

  fd.append("_subject", `Neue KO STOP Konfigurator-Bestellung ${orderId}`);
  fd.append("_replyto", "info@ko-stop.de");
  fd.append("anfrage_id", orderId);

  fd.append("produkt", selected.product_name || "-");
  fd.append("produktfarbe", selected.product_color_label || "-");
  fd.append("verpackung", selected.packaging_label || "-");
  fd.append("verpackungsfarbe", selected.packaging_color_label || "-");
  fd.append("stueckzahl", selected.quantity_label || selected.quantity || "-");
  fd.append("preis_pro_stueck", selected.unit_price || "-");
  fd.append("gesamtpreis", selected.total_price || "-");
  fd.append("shopify_variant_id", selected.variant || "-");
  fd.append("design_elemente", String(state.layers.length));
  fd.append("design_daten_json", JSON.stringify(designLayers, null, 2));

  const screenshots = await captureDesignScreenshots();

  screenshots.forEach(screenshot => {
    fd.append(
      screenshot.fieldName,
      screenshot.file,
      screenshot.fileName
    );
  });

  state.layers.forEach((layer, index) => {
    if (layer.originalFile) {
      fd.append(
        `datei_${index + 1}_${safeFileFieldName(layer.surface)}`,
        layer.originalFile,
        layer.name || `design-${index + 1}`
      );
    }
  });

  const response = await fetch(FORMSPREE_ENDPOINT, {
    method: "POST",
    body: fd,
    headers: {
      "Accept": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error("Formspree error");
  }
}

async function captureDesignScreenshots() {
  const screenshots = [];

  const panel7 = section.querySelector('[data-panel="7"]');
  const oldPanel7Style = panel7 ? panel7.getAttribute("style") : null;
  const wasActive = panel7?.classList.contains("ko-konfig__panel--active");

  if (panel7) {
    panel7.classList.add("ko-konfig__panel--active");
    panel7.style.display = "block";
    panel7.style.visibility = "visible";
    panel7.style.opacity = "1";
    panel7.style.position = "absolute";
    panel7.style.left = "-9999px";
    panel7.style.top = "0";
    panel7.style.width = "1200px";
    panel7.style.pointerEvents = "none";
  }

  await new Promise(resolve => setTimeout(resolve, 500));

  const targets = [
    {
      surface: "product",
      label: "produkt",
      surfaceEl: section.querySelector('[data-role="surface-product"]'),
      baseImg: section.querySelector('[data-role="preview-product-image"]')
    },
    {
      surface: "packaging_front",
      label: "verpackung",
      surfaceEl: section.querySelector('[data-role="surface-packaging"]'),
      baseImg: section.querySelector('[data-role="preview-packaging-image"]')
    }
  ];

  for (const target of targets) {
    const layers = state.layers.filter(layer =>
      layer.surface === target.surface &&
      !layer.isPdf
    );

    if (!target.surfaceEl || !target.baseImg || !layers.length) continue;

    try {
      await waitForImage(target.baseImg);

      const surfaceRect = target.surfaceEl.getBoundingClientRect();
      const imageRect = getContainedImageRect(target.baseImg, target.surfaceEl);

      const canvas = document.createElement("canvas");
      canvas.width = Math.round(surfaceRect.width * 2);
      canvas.height = Math.round(surfaceRect.height * 2);

      const ctx = canvas.getContext("2d");
      ctx.scale(2, 2);

      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, surfaceRect.width, surfaceRect.height);

      ctx.drawImage(
        target.baseImg,
        imageRect.x,
        imageRect.y,
        imageRect.width,
        imageRect.height
      );

      for (const layer of layers) {
        const logoImg = await loadImage(layer.src);

       const screenshotXOffset = {
  product: 0,
  packaging_front: -6
};

const screenshotYOffset = {
  product: 20,
  packaging_front: 35
};

const x =
  surfaceRect.width * (layer.x / 100) +
  (screenshotXOffset[target.surface] || 0);

const y =
  surfaceRect.height * (layer.y / 100) +
  (screenshotYOffset[target.surface] || 0);

        const screenshotScaleMultiplier = {
  product: 0.85,
  packaging_front: 1
};

const logoWidth =
  120 *
  layer.scale *
  (screenshotScaleMultiplier[target.surface] || 1);
        const logoHeight = logoWidth * (logoImg.naturalHeight / logoImg.naturalWidth);

        ctx.save();
        ctx.translate(x, y);
        ctx.rotate((layer.rotation || 0) * Math.PI / 180);
        ctx.drawImage(
          logoImg,
          -logoWidth / 2,
          -logoHeight / 2,
          logoWidth,
          logoHeight
        );
        ctx.restore();
      }

      const blob = await canvasToBlob(canvas);
      if (!blob) continue;

      const fileName = `ko-stop-layout-${target.label}-${Date.now()}.png`;

      screenshots.push({
        fieldName: `layout_screenshot_${target.label}`,
        fileName,
        file: new File([blob], fileName, { type: "image/png" })
      });

    } catch (error) {
      console.error("Canvas Screenshot Fehler:", target.label, error);
    }
  }

  if (panel7) {
    if (!wasActive) panel7.classList.remove("ko-konfig__panel--active");

    if (oldPanel7Style === null) {
      panel7.removeAttribute("style");
    } else {
      panel7.setAttribute("style", oldPanel7Style);
    }
  }

  return screenshots;
}
function getContainedImageRect(img, surfaceEl) {
  const surfaceRect = surfaceEl.getBoundingClientRect();

  const naturalWidth = img.naturalWidth || 1;
  const naturalHeight = img.naturalHeight || 1;

  const surfaceWidth = surfaceRect.width;
  const surfaceHeight = surfaceRect.height;

  const imageRatio = naturalWidth / naturalHeight;
  const surfaceRatio = surfaceWidth / surfaceHeight;

  let width;
  let height;

  if (imageRatio > surfaceRatio) {
    width = surfaceWidth;
    height = width / imageRatio;
  } else {
    height = surfaceHeight;
    width = height * imageRatio;
  }

  return {
    x: (surfaceWidth - width) / 2,
    y: (surfaceHeight - height) / 2,
    width,
    height
  };
}
function waitForImage(img) {
  if (!img) return Promise.resolve();

  if (img.complete && img.naturalWidth > 0) {
    return Promise.resolve();
  }

  return new Promise(resolve => {
    img.onload = resolve;
    img.onerror = resolve;
  });
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

function getDesignSurfaceElement(surface) {
  const layerContainer = getLayerContainer(surface);

  return layerContainer?.closest(".ko-konfig__design-surface") ||
    layerContainer?.parentElement ||
    null;
}

async function elementToPngBlob(element) {
  if (window.html2canvas && typeof window.html2canvas === "function") {
    const canvas = await window.html2canvas(element, {
      backgroundColor: null,
      scale: Math.min(window.devicePixelRatio || 2, 2),
      useCORS: true
    });

    return canvasToBlob(canvas);
  }

  return elementToPngBlobWithSvgFallback(element);
}

async function elementToPngBlobWithSvgFallback(element) {
  const rect = element.getBoundingClientRect();
  const width = Math.max(1, Math.round(rect.width));
  const height = Math.max(1, Math.round(rect.height));
  const clone = element.cloneNode(true);

  inlineComputedStyles(element, clone);

  const serialized = new XMLSerializer().serializeToString(clone);
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
      <foreignObject width="100%" height="100%">
        <div xmlns="http://www.w3.org/1999/xhtml" style="width:${width}px;height:${height}px;">
          ${serialized}
        </div>
      </foreignObject>
    </svg>
  `;

  const img = new Image();
  const svgBlob = new Blob([svg], { type: "image/svg+xml;charset=utf-8" });
  const url = URL.createObjectURL(svgBlob);

  try {
    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = reject;
      img.src = url;
    });

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, width, height);

    return canvasToBlob(canvas);
  } finally {
    URL.revokeObjectURL(url);
  }
}

function inlineComputedStyles(source, target) {
  const computed = window.getComputedStyle(source);
  target.setAttribute(
    "style",
    Array.from(computed).map(name => `${name}:${computed.getPropertyValue(name)};`).join("")
  );

  Array.from(source.children).forEach((sourceChild, index) => {
    const targetChild = target.children[index];
    if (targetChild) inlineComputedStyles(sourceChild, targetChild);
  });
}

function canvasToBlob(canvas) {
  return new Promise(resolve => {
    canvas.toBlob(blob => resolve(blob), "image/png", 0.92);
  });
}
  function getSerializableLayers() {
    return state.layers.map((layer, index) => ({
      nummer: index + 1,
      dateiname: layer.name || "-",
      flaeche: layer.surface === "product" ? "Produkt" : "Verpackung vorne",
      x_prozent: roundNumber(layer.x),
      y_prozent: roundNumber(layer.y),
      groesse_prozent: roundNumber(layer.scale * 100),
      drehung_grad: roundNumber(layer.rotation),
      dateityp: layer.fileType || "-",
      dateigroesse_mb: layer.fileSize ? roundNumber(layer.fileSize / 1024 / 1024) : null,
      in_live_vorschau_sichtbar: !layer.isPdf
    }));
  }

  function safeFileFieldName(value) {
    return String(value || "datei")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "") || "datei";
  }

  function roundNumber(value) {
    return Math.round(Number(value || 0) * 100) / 100;
  }

  function setImage(img, src) {
    if (!img) return;

    if (src) {
      img.src = src;
      img.hidden = false;
      img.style.display = "";
    } else {
      clearImage(img);
    }
  }

  function clearImage(img) {
    if (!img) return;

    img.removeAttribute("src");
    img.hidden = true;
  }

  function uniqueBy(array, keyFn) {
    const map = new Map();

    array.forEach(item => {
      const key = keyFn(item);

      if (key && !map.has(key)) {
        map.set(key, item);
      }
    });

    return Array.from(map.values());
  }

  function setActive(container, activeButton) {
    if (!container) return;

    container.querySelectorAll("button").forEach(button => {
      button.classList.remove("is-active");
      button.classList.remove("is-selected");
    });

    activeButton.classList.add("is-active");
  }

  function clearGrid(grid) {
    if (grid) grid.innerHTML = "";
  }

  function enable(action) {
    const button = section.querySelector(`[data-action="${action}"]`);
    if (button) button.disabled = false;
  }

  function disable(action) {
    const button = section.querySelector(`[data-action="${action}"]`);
    if (button) button.disabled = true;
  }

  function updateText(role, text) {
    section.querySelectorAll(`[data-role="${role}"]`).forEach(el => {
      el.textContent = text;
    });
  }

  function showError(message) {
    const errorBox = section.querySelector('[data-role="upload-error"]');
    const errorMessage = section.querySelector('[data-role="error-message"]');

    if (errorBox && errorMessage) {
      errorMessage.textContent = message;
      errorBox.hidden = false;

      window.setTimeout(() => {
        errorBox.hidden = true;
      }, 4000);
    } else {
      alert(message);
    }
  }

  function normalizeKey(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replaceAll("ä", "ae")
      .replaceAll("ö", "oe")
      .replaceAll("ü", "ue")
      .replaceAll("ß", "ss")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function escapeHtml(value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }

    return String(value).replace(/["\\]/g, "\\$&");
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }
}